var path = '/templates/core/views/500.html';
var html = "<div id=error-page><div class=error-number>500</div><div class=error-message>{{ 'sharedModules.core.views.500.errorOccurred' | translate }}</div><a ui-sref=admin.home>{{ 'sharedModules.core.views.500.backToHome' | translate }}</a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/500.html
// module id = 1366
// module chunks = 0